export default __webpack_public_path__ + "static/banner-1-fd44f3d50210d5f2e7a2a76d8a69c513.png";